import { useQuery } from '@tanstack/react-query'

import { productUpdatesApi } from '../..'
import { SuccessResponse } from '../../productUpdateTypes'
import { TickerMessageResponse } from './newsTicker.types'

export const NEWS_TICKER_QUERY_KEY = 'NEWS_TICKER'

export const newsTicker = async () => {
  const response =
    await productUpdatesApi.get<SuccessResponse<TickerMessageResponse[]>>(
      '/me/news-tickers'
    )
  return response.data.data
}

export const useNewsTickerQuery = () => {
  return useQuery({
    queryKey: [NEWS_TICKER_QUERY_KEY],
    queryFn: newsTicker
  })
}
